import { render, staticRenderFns } from "./spacer-w16.vue?vue&type=template&id=13047470&scoped=true&"
import script from "./spacer-w16.vue?vue&type=script&lang=js&"
export * from "./spacer-w16.vue?vue&type=script&lang=js&"
import style0 from "./spacer-w16.vue?vue&type=style&index=0&id=13047470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13047470",
  null
  
)

export default component.exports